(() => {


    class ValetBookingCalendar {


        constructor(container) {


            this.container = container;


            this.type = container.dataset.calendarType;


            this.monthSelect =
            container.querySelector('[data-calendar-month]');


            this.yearSelect =
            container.querySelector('[data-calendar-year]');


            this.daysContainer =
            container.querySelector('[data-calendar-days]');


            this.selectedDateInput =
            container.querySelector('[data-selected-date]');



            this.today = new Date();


            this.currentMonth = this.today.getMonth();

            this.currentYear = this.today.getFullYear();



            this.selectedDate = null;

            this.minSelectableDate =
                this.getMinSelectableDate();


            this.currentMonth =
            this.minSelectableDate.getMonth();

            this.currentYear =
            this.minSelectableDate.getFullYear();



            this.init();
            this.container.__calendarInstance = this;
            

        }

        getMinSelectableDate() {

            /*
            |--------------------------------------------------------------------------
            | Collection Calendar
            |--------------------------------------------------------------------------
            */

            if (this.type === "collection") {

                const delivery =
                    window.valetBooking.deliveryDate;

                if (delivery) {

                    const date = new Date(delivery);

                    date.setHours(0, 0, 0, 0);

                    date.setDate(date.getDate() + 2);

                    return date;

                }

            }

            /*
            |--------------------------------------------------------------------------
            | Delivery Calendar
            |--------------------------------------------------------------------------
            */

            const date = new Date(this.today);

            date.setHours(0, 0, 0, 0);

            let businessDays = 0;

            while (businessDays < 3) {

                date.setDate(date.getDate() + 1);

                const day = date.getDay();

                if (day !== 0 && day !== 6) {

                    businessDays++;

                }

            }

            return date;

        }


        init(){



            this.populateSelectors();


            this.bindEvents();


            this.renderCalendar();

            this.updateSelectedDateDisplay();



                }

        populateSelectors(){


            if(this.monthSelect){

                this.monthSelect.value =
                this.currentMonth;

            }


            if(this.yearSelect){

                this.yearSelect.value =
                this.currentYear;

            }


        }

        bindEvents(){



            if(this.monthSelect){


                this.monthSelect.addEventListener(
                'change',
                ()=>{


                    this.currentMonth =
                    parseInt(
                    this.monthSelect.value,
                    10
                    );


                    this.renderCalendar();


                });


            }

            if(this.yearSelect){


                this.yearSelect.addEventListener(
                'change',
                ()=>{


                    this.currentYear =
                    parseInt(
                    this.yearSelect.value,
                    10
                    );


                    this.renderCalendar();


                });


            }


        }


        renderCalendar() {

            // Always recalculate the minimum selectable date
            this.minSelectableDate =
                this.getMinSelectableDate();

            // Only force the collection calendar to the earliest valid month
            if (this.type === "collection") {

                this.currentMonth =
                    this.minSelectableDate.getMonth();

                this.currentYear =
                    this.minSelectableDate.getFullYear();

                if (this.monthSelect) {
                    this.monthSelect.value = this.currentMonth;
                }

                if (this.yearSelect) {
                    this.yearSelect.value = this.currentYear;
                }

            }

            this.daysContainer.innerHTML = "";

            const firstDay =
                new Date(
                    this.currentYear,
                    this.currentMonth,
                    1
                );

            const lastDay =
                new Date(
                    this.currentYear,
                    this.currentMonth + 1,
                    0
                );


            const totalDays =
            lastDay.getDate();




            let startDay =
            firstDay.getDay();



            startDay =
            startDay === 0
            ? 6
            : startDay - 1;

            for(let i=0;i<startDay;i++){


                const empty =
                document.createElement('div');


                empty.className =
                'valet-calendar-day valet-calendar-day--empty';


                this.daysContainer.appendChild(empty);


            }

            for(let day=1; day<=totalDays; day++){



                const button =
                document.createElement('button');



                button.type = 'button';


                button.className =
                'valet-calendar-day';



                button.textContent = day;


                const date =
                new Date(
                    this.currentYear,
                    this.currentMonth,
                    day
                );

                date.setHours(0,0,0,0);

                

                if(
                this.selectedDate &&
                date.toDateString()
                ===
                this.selectedDate.toDateString()
                ){

                    button.classList.add(
                    'valet-calendar-day--selected'
                    );

                }

                console.log(
                    day,
                    date,
                    this.minSelectableDate,
                    date < this.minSelectableDate
                );

                const isWeekend =
                    date.getDay() === 0 ||
                    date.getDay() === 6;

                const isBeforeMin =
                    date < this.minSelectableDate;

                if (isWeekend || isBeforeMin) {

                    button.disabled = true;

                    button.classList.add(
                    'valet-calendar-day--disabled'
                    );

                }

                else {

                    button.addEventListener(
                            "click",
                            () => {

                                this.selectedDate = date;

                                this.updateSelectedDateDisplay();

                                if (this.type === "delivery") {

                                    window.valetBooking.deliveryDate =
                                        new Date(this.selectedDate);

                                    const collectionCalendar =
                                        document.querySelector(
                                            '[data-calendar-type="collection"]'
                                        )?.__calendarInstance;

                                    if (collectionCalendar) {

                                        collectionCalendar.selectedDate = null;

                                        collectionCalendar.renderCalendar();

                                        collectionCalendar.updateSelectedDateDisplay();

                                    }

                                }
                                else {

                                    window.valetBooking.collectionDate =
                                        new Date(this.selectedDate);

                                }

                                this.renderCalendar();

                                const formatted =
                                    this.selectedDate.toLocaleDateString(
                                        "en-SG",
                                        {
                                            day: "numeric",
                                            month: "long",
                                            year: "numeric"
                                        }
                                    );

                                    document
                                    .querySelectorAll(
                                        `[data-summary="${this.type}-date"]`
                                    )
                                    .forEach(item => {

                                        item.textContent = formatted;

                                    });

                                this.container.dispatchEvent(
                                    new CustomEvent(
                                        "calendar:selected",
                                        {
                                            bubbles: true,
                                            detail: {
                                                date: formatted,
                                                rawDate: this.selectedDate,
                                                type: this.type
                                            }
                                        }
                                    )
                            );

                        }
                    );

                }

                this.daysContainer.appendChild(button);

            }

        }

        updateSelectedDateDisplay() {

            const heading =
                this.container.querySelector(
                    "[data-selected-heading]"
                );

            if (!this.selectedDate) {

                if (heading) {

                    heading.textContent =
                        this.type === "collection"
                            ? "Select Collection Date"
                            : "Select Delivery Date";

                }

                if (this.selectedDateInput) {

                    this.selectedDateInput.value = "";

                }

                return;

            }

            const formatted =
                this.selectedDate.toLocaleDateString(
                    "en-SG",
                    {
                        day: "numeric",
                        month: "long",
                        year: "numeric"
                    }
                );

            if (heading) {

                heading.textContent = formatted;

            }

            if (this.selectedDateInput) {

                this.selectedDateInput.value = formatted;

            }

        }

    }


    document.addEventListener(
    'DOMContentLoaded',
    ()=>{


        document
        .querySelectorAll(
        '.valet-booking-calendar'
        )
        .forEach(calendar=>{

            new ValetBookingCalendar(calendar);

        });

    });


})();